import LocalizationService from '@/api/LocalizationService';

const state = {
  countriesWithProvinces: null,
};

const getters = {};

const actions = {
  countriesWithProvinces({ commit }) {
    return LocalizationService.getCountriesWithProvince().then((response) => {
      commit('countriesWithProvinces', response.data);
    });
  },
};

const mutations = {
  countriesWithProvinces(state, payload) {
    state.countriesWithProvinces = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
